import React from 'react'
import type { BaseWeatherIconProps } from '../WeatherIcon'

const WeatherIconDaySlightlyCloudy: React.FC<BaseWeatherIconProps> = ({
  className = '',
}) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 100 100"
      fill="none"
      className={className}
    >
      <path d="M32.6882 21H28.8438V32.5444H32.6882V21Z" fill="#F9D23E" />
      <path
        d="M10.3708 28.6531L7.65234 31.3715L15.8076 39.5267L18.526 36.8083L10.3708 28.6531Z"
        fill="#F9D23E"
      />
      <path d="M11.5444 49.8444H0V53.6889H11.5444V49.8444Z" fill="#F9D23E" />
      <path
        d="M15.8076 64.0091L7.65234 72.1644L10.3708 74.8828L18.526 66.7276L15.8076 64.0091Z"
        fill="#F9D23E"
      />
      <path
        d="M51.163 28.6551L43.0078 36.8104L45.7262 39.5288L53.8814 31.3736L51.163 28.6551Z"
        fill="#F9D23E"
      />
      <path
        d="M35.4567 54.5C37.3234 50.4334 40.7011 47.2778 44.8122 45.5445C42.4233 40.1556 37.0456 36.3889 30.7678 36.3889C22.2678 36.3889 15.3789 43.2778 15.3789 51.7778C15.3789 57.6556 18.7122 62.7111 23.5678 65.3C24.89 59.7222 29.5789 55.3889 35.4567 54.5Z"
        fill="#F9D23E"
      />
      <path
        d="M69.9784 65.0222L66.3117 64.9333L66.2228 61.2667C66.0451 53.9111 59.6451 47.9222 51.9673 47.9222C49.8228 47.9222 47.7673 48.3889 45.9006 49.2445C42.8673 50.6222 40.3673 53.0222 38.9562 56.1L38.0895 57.9889L36.0339 58.3C31.5006 58.9889 27.9562 62.4445 27.1784 66.6889C27.0784 67.2556 27.0117 67.8445 27.0117 68.4333C27.0117 74.0889 31.8117 78.6889 37.7006 78.6889H69.7895C73.7228 78.6889 76.9228 75.6222 76.9228 71.8556C76.9339 68.1778 73.8117 65.1111 69.9784 65.0222Z"
        fill="#D2E0FF"
      />
      <path
        d="M95.1885 46.3L92.6552 46.2333L92.5885 43.7C92.4663 38.6 88.033 34.4556 82.7108 34.4556C81.233 34.4556 79.7997 34.7778 78.5108 35.3667C76.4108 36.3222 74.6774 37.9889 73.6997 40.1222L73.0997 41.4333L71.6774 41.6445C68.5441 42.1222 66.0885 44.5222 65.5441 47.4556C65.4663 47.8556 65.4219 48.2556 65.4219 48.6667C65.4219 52.5778 68.7441 55.7667 72.833 55.7667H95.0552C97.7774 55.7667 99.9997 53.6445 99.9997 51.0333C99.9997 48.4889 97.8441 46.3667 95.1885 46.3Z"
        fill="#E8EFFF"
      />
    </svg>
  )
}

export default WeatherIconDaySlightlyCloudy
